<template>
  <form name="editOneOffOrder" @submit="checkForm">
    <div class="card__header">
      <p class="card__title">Information</p>
    </div>
    <div class="card__content">
      <div class="form">
        <div class="form__field form__field--sm6">
          <label for="date" class="form__label">Date</label>
          <label v-if="deliveryDateError" class="error" for="date" style="">Delivery is available from {{ $parent.date }}.</label>
          <input id="date" type="text" class="form__control form-field required datepicker" placeholder="jj/mm/yyyy" v-model="$parent.date" v-on:change="checkIfDeliveryDateIsValid" autocomplete="off">
          <div class="form__icon">
            <icon-calendar></icon-calendar>
          </div>
        </div>
        <div class="form__field form__field--sm6">
          <label for="slot" class="form__label">Time slot</label>
          <select id="slot" class="form__control" v-model="$parent.slot">
            <option :value="slot.id" v-for="(slot) in $parent.slots" :disabled="slot.available === false">
              {{ slot.humanized_slot }} (+ £{{ slot.service_fee.one_off / 100 }}) {{ slot.available === false ? '(time slot full)' : '' }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="card__content">
      <p class="card__subheader">Basket</p>
      <ul class="tabs tabs--sm nav" id="productsNav" role="tablist">
        <li class="tab__wrapper" role="presentation" v-for="(tab, index) in tabs">
          <a v-if="tab" :class="['tab', (index == Object.keys(tabs)[0] ? 'active' : '')]" :id="tab.category.slug+'-tab'" data-toggle="tab" :href="'#'+tab.category.slug" role="tab">
            {{ tab.category.name }}
          </a>
        </li>
      </ul>
      <div class="tabs__content" id="myTabContent">
        <div v-for="(tab, index) in tabs" v-if="tab" :class="['tab__target', (index == Object.keys(tabs)[0] ? 'show active' : '')]" :id="tab.category.slug" role="tabpanel">
          <div class="row product__infosWrapper">
            <div class="col-md-6" v-for="product in tab.products">
              <div class="product__infos" :class="{ 'product__unavailable': !product.can_sale }">
                <div class="product__image"><img :src="'/' + product.image" class="img-fluid" alt=""></div>
                <div class="product__meta">
                  <div class="product__header">
                    <p class="text-16 product__title">{{ product.name }}</p>
                    <div class="qty__wrapper" v-if="product.can_sale">
                      <button type="button" class="button button--sm button--icon button--grey"
                              v-on:click="setQuantity(product, 'ACTION_LESS')">
                        <icon-minus></icon-minus>
                      </button>
                      <p class="text-16 qty">{{ $parent.cart[product.id].qty }}</p>
                      <button type="button" class="button button--sm button--icon button--grey"
                              v-on:click="setQuantity(product, 'ACTION_MORE')">
                        <icon-plus></icon-plus>
                      </button>
                    </div>
                  </div>
                  <div>
                    <div class="text-12">
                      <template v-if="product.food_pairing">
                        {{ product.food_pairing }}.
                      </template>
                      <v-clamp autoresize :max-lines="3">
                        {{ product.description_short }}
                        <template #after="{ toggle, clamped, expanded }">
                          <button v-if="clamped == true || expanded == true" @click="toggle" type="button" class="product__expand button button--xs button--icon button--grey">
                            <template v-if="clamped == true"><icon-chevron-down></icon-chevron-down></template>
                            <template v-else><icon-chevron-up></icon-chevron-up></template>
                          </button>
                        </template>
                      </v-clamp>
                    </div>
                    <div class="mt-05">
                      <!-- product discount -->
                      <!-- <p class="tag tag--sm tag--primary" v-if="product.id === 27 || product.id === 26 || product.id === 53 || product.id === 85 || product.id === 86">15% off</p> -->
                      <span class="text-14 text--bold">
                        £{{ product.price | setDecimals }}
                        <!-- product discount -->
                        <!-- <span class="text--strikeThrough text--regular text--alt">
                          <template v-if="product.id === 27">£4.75</template>
                          <template v-if="product.id === 26">£5.20</template>
                          <template v-if="product.id === 53">£4.75</template>
                          <template v-if="product.id === 85">£4.20</template>
                          <template v-if="product.id === 86">£4.20</template>
                        </span> -->
                      </span>
                    </div>
                    <p class="text-12 text-error mt-05 text--bold" v-if="product.is_tracked && product.stock === 0">Out of stock</p>
                    <p class="text-12 text-error mt-05 text--bold" v-else-if="product.is_tracked && (product.stock - product.qty) === 0">Out of stock</p>
                    <p class="text-12 text-error mt-05 text--bold" v-else-if="product.is_tracked && product.stock <= 5">Only {{ product.stock - product.qty }} remaining</p>
                    <p class="text-12 mt-05">
                      <template v-if="product.start_sale || product.end_sale">
                        Available
                        <span v-if="product.start_sale">from {{ dateFormat(product.start_sale) }}</span>
                        <span v-if="product.end_sale">until {{ dateFormat(product.end_sale) }}</span>
                      </template>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="errors.length" class="form__notice form__notice--error mt-3">
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-for="error in errors">{{ error }}</li>
        </ul>
      </div>
    </div>
    <div class="card__actions">
      <button v-if="$parent.isGift" type="button" class="button button--md button--grey" v-on:click="$parent.step = 'ADDRESS'">Back</button>
      <button type="submit" class="button button--md button--secondary">Next</button>
    </div>
  </form>
</template>

<script>

import VClamp from 'vue-clamp'

export default {

  components: {
    VClamp
  },

  data() {
    return {
      errors: [],
      deliveryDateError: false,
      startDate: null,
      tabs: [],
    }
  },

  beforeMount() {
    this.$parent.products.map((p) => {
      p.categories.map((c) => {
        if (!this.tabs[c.id]) {
          this.tabs[c.id] = {
            category: c,
            products: [],
          };
        }
        this.tabs[c.id].products.push(p);
      });
    });

    this.tabs = this.tabs.sort((a,b) => {
      return a.category.rgt - b.category.rgt;
    });

    if (this.$parent.date) {
      const d = moment(this.$parent.date, 'DD/MM/YYYY').toDate();
      d.setUTCDate(d.getDate());
      d.setUTCHours(0);
      this.$parent.updateProductsPeriodAvailability(d);
    }
  },

  mounted() {
    let closingTime = new Date();
    closingTime.setHours(window.config.closing_time);

    let now = new Date();
    //now.setHours(now.getUTCHours());

    let startDate = new Date();
    startDate.setDate(startDate.getDate() + 2);

    // Allow order for tomorrow until specific hours, or +2 days
    if (now.getHours() >= closingTime.getHours()) {
      startDate.setDate(startDate.getDate() + 2);
    }
    startDate.setHours(0);
    startDate.setMinutes(0);
    startDate.setSeconds(0);
    startDate.setMilliseconds(0);
    this.startDate = startDate;


    this.getHalfDays(this.$parent.address.postcode);
  },

  methods: {

    getHalfDays(zipcode) {
      axios.get(`/api/zipcode/${zipcode}`).then(res => {
        this.$parent.halfDays = res.data.datas.half_days;

        this.$parent.halfDays.forEach((halfDay, index) => {
          const day = halfDay.code.split('_')[0];
          this.$parent.halfDays[index].day = day;
          if (day === 'SUNDAY') this.$parent.halfDays[index].dayNumber = 0;
          if (day === 'MONDAY') this.$parent.halfDays[index].dayNumber = 1;
          if (day === 'TUESDAY') this.$parent.halfDays[index].dayNumber = 2;
          if (day === 'WEDNESDAY') this.$parent.halfDays[index].dayNumber = 3;
          if (day === 'THURSDAY') this.$parent.halfDays[index].dayNumber = 4;
          if (day === 'FRIDAY') this.$parent.halfDays[index].dayNumber = 5;
          if (day === 'SATURDAY') this.$parent.halfDays[index].dayNumber = 6;
        });

        // Set datepicker and load slots on change
        $('.datepicker').datepicker({
          format: 'dd/mm/yyyy',
          weekStart: 1,
          startDate: this.startDate,
          autoclose: true,
          halfDays: this.$parent.halfDays,
          beforeShowDay: function(date) {
            let dayNumber = date.getDay();

            // Can't order monday and tuesday
            if (dayNumber === 1 || dayNumber === 2) {
              return false;
            }

            // closing dates
            let startHoliday = new Date('2024-11-30 00:00:00'); // start date
            let endHoliday = new Date('2025-12-31 00:00:00'); // resume date
            if (date >= startHoliday && date < endHoliday) {
              return false;
            }

            return !!this.halfDays.find(e => {
              let startAt = new Date(e.pivot.start_at);
              startAt.setHours(0);
              startAt.setMinutes(0);
              startAt.setSeconds(0);

              if (e.pivot.end_at) {
                let endAt = new Date(e.pivot.end_at);
                endAt.setHours(0);
                endAt.setMinutes(0);
                endAt.setSeconds(0);
                return e.dayNumber === dayNumber && date >= startAt && date <= endAt;
              }

              return e.dayNumber === dayNumber && date >= startAt;
            });
          }
        }).on('changeDate', (e) => {
          this.deliveryDateError = false;
          this.$parent.promotion_total = null;
          this.$parent.total = null;
          this.$parent.date = e.target.value;
          this.$parent.getSlots(this.$parent.date, true);
          this.$parent.slot = null;
          e.date.setUTCDate(e.date.getDate());
          e.date.setUTCHours(0);

          this.$parent.updateProductsPeriodAvailability(e.date);
        });

      }).catch(error => console.log(error));
    },

    checkForm: function (e) {
      e.preventDefault();

      let productQty = 0;
      $.each(this.$parent.cart, (index, item) => {
        productQty += item.qty;
      });

      this.errors = [];
      if (!this.$parent.date) {
        this.errors.push('Delivery date is required.');
      }
      if (!this.$parent.slot) {
        this.errors.push('Time slot is required.');
      }
      if (productQty === 0) {
        this.errors.push('Please select at least 1 product.');
      }

      if (this.errors.length === 0) {
        if (this.$parent.promotion_code) {
          // this.$parent.validateOrder();
        }

        this.$parent.step = 'SUMMARY';

        let element = document.getElementById('order-modal');
        element = element.closest('.popup-content__inner');
        element.scrollTo(0, 0);
      }
    },

    checkIfDeliveryDateIsValid(event) {
      this.deliveryDateError = false;
      let deliveryDate = moment(this.$parent.date, 'DD/MM/YYYY').toDate()
      if (deliveryDate < this.startDate) {
        this.$parent.date = moment(this.startDate).format('DD/MM/YYYY');
        this.deliveryDateError = true;
      }
    },

    setQuantity(product, action) {
      if (action === 'ACTION_MORE') {
        if (this.$parent.cart[product.id].qty < 15) {
          if (product.is_tracked) {
            if (this.$parent.cart[product.id].qty < product.stock) {
              this.$parent.cart[product.id].qty++;
            }
          }
          else {
            this.$parent.cart[product.id].qty++;
          }
        }

      } else {
        if (this.$parent.cart[product.id].qty > 0) {
          this.$parent.cart[product.id].qty--;
        }
      }

      this.$parent.promotion_total = null;
      this.$parent.total = null;
    },

    dateFormat(date) {
      function pad(s) { return (s < 10) ? '0' + s : s; }
      let d = new Date(date);
      return [pad(d.getDate()), pad(d.getMonth()+1)].join('/');
    }
  }
}
</script>
